'use es6';

import { create } from './strings';
export const get = (spec, config) => {
  const {
    filters = {}
  } = spec;
  return Object.keys(filters).reduce((params, property) => Object.assign({}, params, create(property).get(spec, config)), {});
};